import { setStoreData,getType } from '@/common/tolls.js'

var formatTree = function(root) {
	var result = root.filter(v=>v.pid==0);
	if(result.length>0) {
		result = getChild(result,root)
	}
	return result;
}

var getChild = function(arr,root) {
	var result = arr.map(v=>{
		var second = root.filter(v1=>v1.pid == v.id);
		if(second.length > 0) {
			v.children = second;
			getChild(second,root)
		}
		return v;
	});

	return result;
}

var mutation = {
	changeStatus(state,{ obj, index }) {
		var obj1 = state[obj];
		obj1[index].show = !obj1[index].show;
		state[obj] = Object.assign({}, obj1);
	},
	changeSelected(state,{selectedMsg1}) {
		selectedMsg1&&(state.selectedMsg1 = selectedMsg1);
		// selectedMsg2&&(state.selectedMsg2 = selectedMsg2);
	},
	setTrees(state,{ trees }) {
		if(trees) {
			let tree = formatTree(trees);

      let list=[];

       for(let i=0; i<tree.length; i++){
            tree[i].value = tree[i].id;
            tree[i].label = tree[i].title;
            if(tree[i].children !=undefined){
                for(let j=0; j< tree[i].children.length; j++){
                  tree[i].children[j].value = tree[i].children[j].id;
                  tree[i].children[j].label = tree[i].children[j].title;
                }
                }
            }
          state.trees = tree;
			if(window.localStorage.getItem('Ttreeinfo')){
				let Ttreeinfo = window.localStorage.getItem('Ttreeinfo');
				Ttreeinfo = JSON.parse(Ttreeinfo);
				state.tree_info = [];//将tree_info 置空
				state.tree_info = Ttreeinfo;
			}else{
				state.tree_info = [];//将tree_info 置空
				state.tree_info = [tree[0],tree[0].children[0]];  //将目录树的第一条内容,及第一条内容子内容的第一条存入tree_info
				state.tree_infos = [tree[0].id,tree[0].children[0].id]; //将目录树的第一条内容,及第一条内容子内容的第一条存入tree_info
				state.jie = tree[0].children[0].id;

			}
		}

	},
	setData(state, {data, field} ) {
		data && (state[field] = data);
	},
	setStoreData(state, { key, data}) {
		setStoreData(state,key,data);
	},
  setjie(state,{id}){
    state.jie = id;
  },
  substreeInfo(state,{id}){
    state.tree_infos = id
  },
	setData2(state,{ data, parent, child }) {
		var parentData = Object.assign({},state[parent]);
		parentData[child] = data;
		state[parent] = parentData;
	},
	setVersion(state,{ field, data, prevIndex, prevData }) {
		if(field == 'subjects') {
			state.versions['subjects'] = data;
		}else if (field == 'publishers') {
			state.versions['publishers'] = data;
		}else if(field == 'grade') {
			state.versions['grade'] = data;
		}

		// if(field == 'subjects') {
		// 	state.versions['publishers'] = [];
		// }

		field&&data&&(state.versions[field] = data);
		if(prevData) {
			let selectedMsg1 = [...state.selectedMsg1];
			selectedMsg1[prevIndex] = prevData;
			state.selectedMsg1 = selectedMsg1;
		}
	},
	setSelect2(state,data) {
		state.grades = data;
	}
}
export default mutation



// WEBPACK FOOTER //
// ./src/store/modules/teaching/mutation.js